
import { useEffect, useRef } from "react";

/**
 * @name useEdgeWheelDetect 监听、滚动是否 到顶部、底部，触发回调
 */
export default function useEdgeWheelDetect(
  element: React.RefObject<HTMLDivElement & { _outerRef?: HTMLElement }>,
  onTopWheel?: (e: WheelEvent) => void,
  onBottomWheel?: (e: WheelEvent) => void,
  duration: number = 200
) {
  const topWheelRef = useRef(onTopWheel);
  const bottomWheelRef = useRef(onBottomWheel);

  useEffect(() => {
    topWheelRef.current = onTopWheel;
    bottomWheelRef.current = onBottomWheel;
  }, [onTopWheel, onBottomWheel]);

  useEffect(() => {
    function handleWheel(e: WheelEvent) {
      const target = element.current?._outerRef;
      if (!target) return;

      // 只处理事件目标在容器内的情况，防止遮挡误触
      if (!target.contains(e.target as Node)) return;

      const rect = target.getBoundingClientRect();
      const inside =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;

      if (!inside) return;

      const atTop = target.scrollTop <= 1;
      const atBottom =
        target.scrollTop + target.clientHeight >= target.scrollHeight - 1;
      const noScroll = target.scrollHeight <= target.clientHeight;

      if ((atTop || noScroll) && e.deltaY < 0) {
        topWheelRef.current && topWheelRef.current(e);
      }
      if ((atBottom || noScroll) && e.deltaY > 0) {
        bottomWheelRef.current && bottomWheelRef.current(e);
      }
    }

    window.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, [element, duration]);
}